import React from 'react';

import { Color, ComponentSize } from '../../../typings/design-tokens';
import { IComponent } from '../../../typings/generic-component';
import { makeClassNames } from '../../../utils/styles';
import IconArrowLink from '../icons/icon-arrow-link';
import './arrow-link.scss';

export interface IArrowLink extends IComponent {
  link?: string | null;
  reverse?: boolean;
  onClick?: (id: number | string | undefined) => void;
  id?: number | string;
}

const DEFAULT_ICON_SIZE: ComponentSize = 'xxsmall';
const DEFAULT_ICON_COLOR: Color = 'red-light';

const classNames = () =>
  makeClassNames({
    arrowLink: 'arrow-link',
  });

const ArrowLink = ({
  /* istanbul ignore next: default value */ size = DEFAULT_ICON_SIZE,
  /* istanbul ignore next: default value */ color = DEFAULT_ICON_COLOR,
  /* istanbul ignore next: default value */ reverse = false,
  onClick,
  id,
  link,
}: IArrowLink) => {
  const cn = classNames();

  return link ? (
    <a href={link} className={cn.arrowLink}>
      <IconArrowLink size={size} color={color} reverse={reverse} />
    </a>
  ) : (
    <a className={cn.arrowLink} onClick={() => (onClick ? onClick(id) : undefined)}>
      <IconArrowLink size={size} color={color} reverse={reverse} />
    </a>
  );
};

export default ArrowLink;
